import React, { useState } from 'react';
import { t } from '../lib/i18n';
import { Link } from 'react-router-dom';
import { User, LogOut, Shield, ChevronDown, Bell, ShoppingCart, Trash2, Megaphone } from 'lucide-react';
import DeleteAccountDialog from './DeleteAccountDialog';
import { useAuth } from '../context/AuthContext';
import { openAlerts } from './AlertsDialog';

const UserMenu = () => {
  const { user, isAdmin, logout, openAuth } = useAuth();
  const isAdvertiser = user?.role === 'advertiser';
  const [open, setOpen] = useState(false);
  const [deleting, setDeleting] = useState(false);

  if (!user) {
    return (
      <button onClick={openAuth} data-testid="nav-user-icon" aria-label={t('Se connecter')}
        className="flex items-center gap-2 w-10 md:w-auto justify-center md:px-3 h-10 rounded-full hover:bg-white/10 transition-colors text-white md:text-[#B3B3B3] hover:text-white text-sm font-semibold">
        <User size={22} className="md:hidden" />
        <User size={20} className="hidden md:block" />
        <span className="hidden md:inline">{t('Se connecter')}</span>
      </button>
    );
  }

  return (
    <div className="relative">
      <button onClick={() => setOpen(!open)} data-testid="nav-user-menu" aria-label={user.name || user.email}
        className="flex items-center gap-2 px-1.5 md:px-3 h-10 rounded-full hover:bg-white/10 transition-colors text-white text-sm font-semibold">
        <span className="w-7 h-7 rounded-full bg-[#E50914] flex items-center justify-center text-xs font-black uppercase">
          {user.name?.[0] || user.email[0]}
        </span>
        <span className="hidden md:inline max-w-[120px] truncate">{user.name || user.email}</span>
        <ChevronDown size={14} className={`hidden md:block transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="absolute end-0 top-12 z-40 w-56 bg-[#141414] border border-[#262626] rounded-md shadow-2xl py-2" data-testid="user-dropdown">
            <div className="px-4 py-2 border-b border-[#262626]">
              <p className="text-xs text-[#808080] truncate">{user.email}</p>
              {isAdmin && <span className="text-[10px] uppercase tracking-wider text-[#E50914] font-bold">{t('Administrateur')}</span>}
              {isAdvertiser && <span className="text-[10px] uppercase tracking-wider text-[#E50914] font-bold">{t('Annonceur')}</span>}
            </div>
            {isAdvertiser && (
              <Link to="/annonceur" onClick={() => setOpen(false)} data-testid="nav-advertiser-link"
                className="flex items-center gap-3 px-4 py-2.5 text-sm font-bold text-white bg-[#E50914]/15 hover:bg-[#E50914]/30">
                <Megaphone size={16} /> {t('Espace annonceur')}
              </Link>
            )}
            {isAdmin && (
              <Link to="/admin" onClick={() => setOpen(false)} data-testid="nav-admin-link"
                className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
                <Shield size={16} /> {t('Espace admin')}
              </Link>
            )}
            <button onClick={() => { setOpen(false); openAlerts(); }} data-testid="nav-alerts-btn"
              className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <Bell size={16} /> {t('Alertes nouveaux catalogues')}
            </button>
            <Link to="/liste" onClick={() => setOpen(false)} data-testid="nav-list-link"
              className="flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <ShoppingCart size={16} /> {t('Liste de courses')}
            </Link>
            <button onClick={() => { setOpen(false); logout(); }} data-testid="nav-logout-btn"
              className="w-full flex items-center gap-3 px-4 py-2.5 text-sm text-[#B3B3B3] hover:bg-white/10 hover:text-white">
              <LogOut size={16} /> {t('Se déconnecter')}
            </button>
            {!isAdmin && (
              <button onClick={() => { setOpen(false); setDeleting(true); }} data-testid="nav-delete-account-btn"
                className="w-full flex items-center gap-3 px-4 py-2.5 text-xs text-[#808080] hover:bg-red-500/10 hover:text-red-400 border-t border-[#262626] mt-1">
                <Trash2 size={14} /> {t('Supprimer mon compte')}
              </button>
            )}
          </div>
        </>
      )}
      {deleting && <DeleteAccountDialog onClose={() => setDeleting(false)} />}
    </div>
  );
};

export default UserMenu;
